// extracted by mini-css-extract-plugin
export default {"list":"Items-module__list--Zovv0"};